import { render, staticRenderFns } from "./LandResources.vue?vue&type=template&id=57b030b6&scoped=true&"
import script from "./LandResources.vue?vue&type=script&lang=js&"
export * from "./LandResources.vue?vue&type=script&lang=js&"
import style0 from "./LandResources.vue?vue&type=style&index=0&id=57b030b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b030b6",
  null
  
)

export default component.exports